export default "__VITE_ASSET__BNIMUbCs__"